import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { katexify } from 'bundles/author-common/utils/katex';
import { KATEX_PARSE_ERROR } from 'bundles/cml/editor/components/elements/math/constants';
import Tex from 'bundles/phoenix/components/Tex';

type Props = {
  formula: string;
  onError: (error: string | undefined) => void;
};

const MathFormula = ({ formula, onError }: Props) => {
  const [renderedKatex, setRenderedKatex] = useState('');
  const [error, setError] = useState<string | undefined>();

  const handleError = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    (value: string | undefined) => {
      setError(value);
      onError(value);
    },
    [onError]
  );

  useEffect(() => {
    let renderError: string | undefined;
    setRenderedKatex(
      katexify(formula, (latex, err) => {
        renderError = err.replace(KATEX_PARSE_ERROR, '');
      })
    );
    handleError(renderError);
  }, [formula, handleError]);

  if (error) {
    // to be consistent with rendered cml, use mathjax via Tex
    return <Tex key={formula}>{formula}</Tex>;
  }

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: renderedKatex }}
    />
  );
};

export default MathFormula;
